import script from "./slideProductFive.vue?vue&type=script&setup=true&lang=js"
export * from "./slideProductFive.vue?vue&type=script&setup=true&lang=js"

import "./slideProductFive.vue?vue&type=style&index=0&id=25e13073&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25e13073"]])

export default __exports__